
import React, {FC} from 'react';
import classNames from 'classnames';
import {Section as Query} from 'templates/reports/query';
import {Section as Config} from 'templates/reports/types';

import DownIcon from './arrow-down.svg';
import SideIcon from './arrow-side.svg';
import UpIcon from './arrow-up.svg';

import * as styles from './styles.module.scss';

type StatsProps = {
	cfgs: NonNullable<Config['details']['card']>
	curr: Query['results'][0]
	prev?: Query['results'][0]
}

const Stats: FC<StatsProps> = ({cfgs, curr, prev}) => {
	const [currValue, units] = cfgs.fmt(curr.value, curr.parse);
	if (!curr.value) {
		curr.value = parseInt(currValue);
		if (prev) {
			prev.value = parseInt(cfgs.fmt(prev.value, prev.parse)[0]);
		}
	}
	return (
		<div className={styles.wrapper}>
			{prev && (
				<>
					<div className={classNames(styles.block, styles.prev)}>
						<div className={styles.value}>
							{cfgs.fmt(prev.value, prev.parse)[0]}
						</div>
						<div className={styles.date}>
							{prev.start.short}
						</div>
					</div>
					{(cfgs.title === 'Bone density') ? (
						<img src={SideIcon as string} className={styles.boneArrow} />
					) : ((prev.value < curr.value) ? (
						<img src={UpIcon as string} />
					) : (
						<img src={DownIcon as string} />
					))}
				</>
			)}
			<div className={styles.block}>
				<div className={styles.value}>
					{currValue}{units}
				</div>
				<div className={styles.date}>
					{curr.start.short}
				</div>
			</div>
		</div>
	);
};

export default Stats;
